import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-barcode",
  "use": "icon-barcode-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-barcode\"><path d=\"M0 18v-12h2v12h-2zm4 0v-12h2v12h-2zm4 0v-12h1v12h-1zm8 0v-12h1v12h-1zm-5 0v-12h3v12h-3zm8 0v-12h2v12h-2zm4 0v-12h1v12h-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/barcode.svg
// module id = vxWv
// module chunks = 11